import Layout from '../../layouts/FullScreenLayout'
import ResetPassword from './ResetPassword'

export default Layout(ResetPassword)
